import type { HoldingsBenchmarkCategory } from 'venn-api';

export const mockHoldingsSectorCategoriesData: HoldingsBenchmarkCategory[] = [
  {
    id: {
      id: 'EQUITY',
    },
    categoryName: 'Equity',
    ordering: 1,
    benchmarkFundUuid: null,
    children: [
      {
        id: {
          id: '796',
        },
        categoryName: 'Cyclical',
        ordering: 1,
        benchmarkFundUuid: null,
        children: [
          {
            id: {
              id: '797',
            },
            categoryName: 'Basic Materials',
            ordering: 1,
            benchmarkFundUuid: null,
            children: [],
          },
          {
            id: {
              id: '818',
            },
            categoryName: 'Consumer Cyclical',
            ordering: 1,
            benchmarkFundUuid: null,
            children: [],
          },
          {
            id: {
              id: '851',
            },
            categoryName: 'Financial Services',
            ordering: 1,
            benchmarkFundUuid: null,
            children: [],
          },
          {
            id: {
              id: '873',
            },
            categoryName: 'Real Estate',
            ordering: 1,
            benchmarkFundUuid: null,
            children: [],
          },
        ],
      },
      {
        id: {
          id: '888',
        },
        categoryName: 'Defensive',
        ordering: 1,
        benchmarkFundUuid: null,
        children: [
          {
            id: {
              id: '889',
            },
            categoryName: 'Consumer Defensive',
            ordering: 1,
            benchmarkFundUuid: null,
            children: [],
          },
          {
            id: {
              id: '908',
            },
            categoryName: 'Healthcare',
            ordering: 1,
            benchmarkFundUuid: null,
            children: [],
          },
          {
            id: {
              id: '927',
            },
            categoryName: 'Utilities',
            ordering: 1,
            benchmarkFundUuid: null,
            children: [],
          },
        ],
      },
      {
        id: {
          id: '936',
        },
        categoryName: 'Sensitive',
        ordering: 1,
        benchmarkFundUuid: null,
        children: [
          {
            id: {
              id: '937',
            },
            categoryName: 'Communication Services',
            ordering: 1,
            benchmarkFundUuid: null,
            children: [],
          },
          {
            id: {
              id: '948',
            },
            categoryName: 'Energy',
            ordering: 1,
            benchmarkFundUuid: null,
            children: [],
          },
          {
            id: {
              id: '959',
            },
            categoryName: 'Industrials',
            ordering: 1,
            benchmarkFundUuid: null,
            children: [],
          },
          {
            id: {
              id: '994',
            },
            categoryName: 'Technology',
            ordering: 1,
            benchmarkFundUuid: null,
            children: [],
          },
        ],
      },
    ],
  },
  {
    id: {
      id: 'BOND',
    },
    categoryName: 'Fixed Income',
    ordering: 1,
    benchmarkFundUuid: null,
    children: [
      {
        id: {
          id: '1321',
        },
        categoryName: 'Cash And Equivalents',
        ordering: 1,
        benchmarkFundUuid: null,
        children: [
          {
            id: {
              id: '1351',
            },
            categoryName: 'Cash And Equivalents',
            ordering: 1,
            benchmarkFundUuid: null,
            children: [],
          },
        ],
      },
      {
        id: {
          id: '1310',
        },
        categoryName: 'Corporate',
        ordering: 1,
        benchmarkFundUuid: null,
        children: [
          {
            id: {
              id: '1311',
            },
            categoryName: 'Bank Loan',
            ordering: 1,
            benchmarkFundUuid: null,
            children: [],
          },
          {
            id: {
              id: '1312',
            },
            categoryName: 'Convertible',
            ordering: 1,
            benchmarkFundUuid: null,
            children: [],
          },
          {
            id: {
              id: '1313',
            },
            categoryName: 'Corporate Bond',
            ordering: 1,
            benchmarkFundUuid: null,
            children: [],
          },
          {
            id: {
              id: '1314',
            },
            categoryName: 'Preferred',
            ordering: 1,
            benchmarkFundUuid: null,
            children: [],
          },
        ],
      },
      {
        id: {
          id: '1322',
        },
        categoryName: 'Derivative',
        ordering: 1,
        benchmarkFundUuid: null,
        children: [
          {
            id: {
              id: '1324',
            },
            categoryName: 'Future Forward',
            ordering: 1,
            benchmarkFundUuid: null,
            children: [],
          },
          {
            id: {
              id: '1325',
            },
            categoryName: 'Option Warrant',
            ordering: 1,
            benchmarkFundUuid: null,
            children: [],
          },
          {
            id: {
              id: '1323',
            },
            categoryName: 'Swap',
            ordering: 1,
            benchmarkFundUuid: null,
            children: [],
          },
        ],
      },
      {
        id: {
          id: '1348',
        },
        categoryName: 'Government',
        ordering: 1,
        benchmarkFundUuid: null,
        children: [
          {
            id: {
              id: '1305',
            },
            categoryName: 'Government',
            ordering: 1,
            benchmarkFundUuid: null,
            children: [],
          },
          {
            id: {
              id: '1306',
            },
            categoryName: 'Government Related',
            ordering: 1,
            benchmarkFundUuid: null,
            children: [],
          },
        ],
      },
      {
        id: {
          id: '1307',
        },
        categoryName: 'Municipal',
        ordering: 1,
        benchmarkFundUuid: null,
        children: [
          {
            id: {
              id: '1308',
            },
            categoryName: 'Municipal Taxable',
            ordering: 1,
            benchmarkFundUuid: null,
            children: [],
          },
          {
            id: {
              id: '1309',
            },
            categoryName: 'US Municipal Tax Advantaged',
            ordering: 1,
            benchmarkFundUuid: null,
            children: [],
          },
        ],
      },
      {
        id: {
          id: '1315',
        },
        categoryName: 'Securitized',
        ordering: 1,
        benchmarkFundUuid: null,
        children: [
          {
            id: {
              id: '1316',
            },
            categoryName: 'Agency Mortgage Backed',
            ordering: 1,
            benchmarkFundUuid: null,
            children: [],
          },
          {
            id: {
              id: '1320',
            },
            categoryName: 'Asset Backed',
            ordering: 1,
            benchmarkFundUuid: null,
            children: [],
          },
          {
            id: {
              id: '1318',
            },
            categoryName: 'Commercial Mortgage Backed',
            ordering: 1,
            benchmarkFundUuid: null,
            children: [],
          },
          {
            id: {
              id: '1319',
            },
            categoryName: 'Covered Bond',
            ordering: 1,
            benchmarkFundUuid: null,
            children: [],
          },
          {
            id: {
              id: '1317',
            },
            categoryName: 'Non Agency Residential Mortgage Backed',
            ordering: 1,
            benchmarkFundUuid: null,
            children: [],
          },
        ],
      },
    ],
  },
  {
    id: {
      id: 'unknown',
    },
    categoryName: '',
    ordering: 1,
    benchmarkFundUuid: null,
    children: [
      {
        id: {
          id: 'UNKNOWN',
        },
        categoryName: 'Unknown',
        ordering: 1,
        benchmarkFundUuid: null,
        children: [],
      },
    ],
  },
];
